import {
    boolYesNoType, multiFileUploadField,
} from '../commons';


const form = {
    title: "DD Cumplimiento",
    displayName: 'ComplianceCaseReview',
    page: 'compliance-case-review',
    commentFieldsMap: {
        "Comentarios Area": "clients[$idx].retailClientDueDiligenceReport.areaComments",
        "Comentarios Cumplimiento": "clients[$idx].retailClientDueDiligenceReport.comments",
    },
};


form.schema = {
    title: "Debida Diligencia Persona Física - Cumplimiento",
    type: "object",
    properties: {
        "tipoPersona": {
            title: "Tipo de Persona",
            type: "number",
            enum: [0, 1, 2, 3, 4],
            enumNames: [" ","Nacional", "Menores de Edad", "Extranjero Residente", "Extranjero No Residente",],
        },
        "tipoCliente": {
            title: "Tipo de Cliente",
            type: "number",
            enum: [0, 1, 2],
            enumNames: [" ","Persona Física", "Persona Jurídica"],
        },
        "nivelRiesgo": {
            title: "Nivel de Riesgo",
            type: "number",
            enumNames: ["Alto", "Medio", "Bajo"],
            enum: [3, 2, 1]
        },
        "PEP": {
            title: "Persona Políticamente Expuesta (PEP)",
            type: "string",
            enum: ["Si, es PEP y proporcionó DJP", "Si, es PEP por Vinculación",
                "No es PEP", "Dejo de ser PEP acorde a la Ley",
                "La coincidencia PEP no es acorde a la Ley, No sera considerado una PEP",],
        },
        "beneficiarioFinal": {
            title: "Beneficiario Final",
            type: "object",
            properties: {
                "identificacionBeneficiarioFinal": {
                    title: "Identificación de Beneficiario Final",
                    type: "number",
                    enum: [0, 1, 2, 3],
                    enumNames: [" ","Si", "No", "No Aplica- Cliente es el único beneficiario",],
                },
            }
        },
        "procedenciaDestinoFondos": {
            title: "Procedencia y destino de Fondos",
            type: "object",
            properties: {
                "origenFondos": {
                    title: "Origen de los Fondos",
                    ...boolYesNoType
                },
                "destinoFondos": {
                    title: "Destino de Fondos",
                    type: "number",
                    enum: [0, 1, 2, 3],
                    enumNames: [" ", "Si", "No", "No Aplica"],
                },
            },
        },
        "validacionAnexos": {
            title: "Validación de anexos",
            type: "object",
            properties: {
                "consultasListas": { title: "Consultas en Listas", type: "boolean" },
                "matrizRiesgo": { title: "Matriz de Riesgo", type: "boolean" }
            },
        },
        "debidaDiligenciaCumplimiento": {
            title: "Debida Diligencia Cumplimiento",
            type: "object",
            properties: {
                "revisionEnListas": {
                    title: " ",
                    description: "Revisión en listas",
                    type: "object",
                    properties: {
                        "title1": { title: "Compliance Screening (World Check)", type: "null", },
                        "complianceScreening": multiFileUploadField.schema,
                        "resultadoConsultaWorldCheck": {
                            title: "Resultado Consulta World Check",
                            type: "string",
                            enum: [
                                "Sin novedad",
                                "Resultados son Falsos Positivos",
                                "Los resultados son positivos, se requiere documentacion adicional",
                                "Los resultados indican que es una PEP"
                            ],
                        },
                        "title2": { title: "Open Corporates", type: "null", },
                        "openCorporates": multiFileUploadField.schema,
                        "resultadoConsultaOpenCorporates": {
                            title: "Resultado Consulta Open Corporates",
                            type: "string",
                            enum: [
                                "Sin novedad",
                                "Resultados son Falsos Positivos",
                                "Los resultados son positivos, se requiere documentacion adicional",
                                "Los resultados indican que es una PEP"
                            ],
                        },
                        "title3": { title: "Consulta Web", type: "null", },
                        "consultaWeb": multiFileUploadField.schema,
                        "resultadoConsultaWeb": {
                            title: "Resultado Consulta Web",
                            type: "string",
                        },
                    },
                },
                "observacionesAreaCumplimiento": {
                    title: "Observaciones Área de Cumplimiento",
                    type: "string",
                },
                "fechaRevision": {
                    title: "Fecha de revisión",
                    type: "string",
                    format: "date",
                },
                // "resultadoDebidaDiligencia": {
                //     title: "Resultado Debida Diligencia",
                //     type: "string",
                //     enum: [
                //         "Aprobado",
                //         "Rechazado",
                //         "Aprobado con excepción",
                //         "Devuelto",
                //         "Requerimiento de información adicional",
                //     ],
                // },
            },
            // dependencies: {
            //     "resultadoDebidaDiligencia": {
            //         oneOf:[
            //             {
            //                 properties: {
            //                     "resultadoDebidaDiligencia": {
            //                         const: "Devuelto"
            //                     },
            //                     "razonDevolucion": {
            //                         title: "Razon de Devolución",
            //                         type: "string",
            //                         enum: [
            //                             "Documento cargado no cumple con requerimientos",
            //                             "Documento o información faltante",
            //                             "Error en digitación de información",
            //                             "Información incorrecta",
            //                             "Otros",
            //                         ],
            //                     },
            //                     "comentarios": {
            //                         title: "Comentarios Internos o Devolución",
            //                         type: "string",
            //                     },
            //                 },
            //             },
            //             {
            //                 properties: {
            //                     "resultadoDebidaDiligencia": {
            //                         const: "Aprobado con excepción"
            //                     },
            //                     "comentarios": {
            //                         title: "Comentarios Internos o Devolución",
            //                         type: "string",
            //                     },
            //                 },
            //             },
            //             {properties: { "resultadoDebidaDiligencia": { const: "Aprobado" }}},
            //             {properties: { "resultadoDebidaDiligencia": { const: "Rechazado" }}},
            //             {properties: { 
            //                 "resultadoDebidaDiligencia": { const: "Requerimiento de información adicional" },
            //                 "comentarios": {
            //                         title: "Información adicional solicitada",
            //                         type: "string",
            //                     },
            //             }},
            //         ],
            //     },
            // },
        },
    },
    required: [],
    dependencies: {
        "tipoPersona": {
            oneOf: [
                {
                    properties: {
                        "tipoPersona": {
                            const: 0
                        },
                    }
                },
                {
                    properties: {
                        "tipoPersona": {
                            const: 1
                        },
                        "validacionDocumentosRequeridos": {
                            title: "Validación de Documentos Requeridos",
                            type: "object",
                            properties: {
                                "nacional": {
                                    title: "Nacional",
                                    type: "object",
                                    properties: {
                                        "copiaCedula": {
                                            title: "Copia de cédula de Identidad y Electoral (ambos lados)",
                                            type: "boolean",
                                        },
                                        "documentosFuenteIngresos": {
                                            title: "Documentos que comprueben la fuente de ingresos",
                                            type: "boolean",
                                        },
                                        "segundaIdentificacion": {
                                            title: "Segunda Identificación (si aplica DDA)",
                                            type: "boolean",
                                        },
                                        "reporteInfoCredenticia": {
                                            title: "Reporte de Información Crediticia",
                                            type: "boolean",
                                        },
                                    },
                                },
                            }
                        },
                    }
                },
                {
                    properties: {
                        "tipoPersona": {
                            const: 2
                        },
                        "validacionDocumentosRequeridos": {
                            title: "Validación de Documentos Requeridos",
                            type: "object",
                            properties: {
                                "menoresEdad": {
                                    title: " ",
                                    description: "Menores de Edad",
                                    type: "object",
                                    properties: {
                                        "cedulaIdentidadMenor": { title: "Copia de cédula de Identidad de menor", type: "boolean" },
                                        "numUnicoIdentidad": { title: "Entre 14 y 17 años, Número Unico de Identidad (NIIU)", type: "boolean" },
                                        "actaNacimiento": { title: "Acta de Nacimiento del Menor u otro documento que evidencie la relación con el menor", type: "boolean" },
                                        "poderRepresentativo": { title: "Documento Legal donde el tutor legal otorga poder de representación", type: "boolean" },
                                        "sentenciaAcreditada": { title: "Sentencia que acredita al representante como tutor", type: "boolean" }
                                    },
                                },
                            }
                        },
                    }
                },
                {
                    properties: {
                        "tipoPersona": {
                            const: 3
                        },
                        "validacionDocumentosRequeridos": {
                            title: "Validación de Documentos Requeridos",
                            type: "object",
                            properties: {
                                "extranjeroResidente": {
                                    title: " ",
                                    description: "Extranjero Residente",
                                    type: "object",
                                    properties: {
                                        "cedulaIdentidad": { title: "Copia de cédula de Identidad de residente permanente o temporal", type: "boolean" },
                                        "pasaporteVigente": { title: "Pasaporte vigente, incluyendo sellos de entrada y salida", type: "boolean" },
                                        "imagenIdentificacion": { title: "Imagen de una o más documentos de identificación de su país de origen", type: "boolean" },
                                        "declaracionImpuesto": { title: "Declaración de Impuesto de su país de origen", type: "boolean" },
                                        "fuenteIngresos": { title: "Documentos que comprueben la fuente de sus ingresos", type: "boolean" }
                                    },
                                },
                            }
                        },
                    }
                },
                {
                    properties: {
                        "tipoPersona": {
                            const: 4
                        },
                        "validacionDocumentosRequeridos": {
                            title: "Validación de Documentos Requeridos",
                            type: "object",
                            properties: {
                                "extranjeroNoResidente": {
                                    title: " ",
                                    description: "Extranjero No Residente",
                                    type: "object",
                                    properties: {
                                        "estatusMigratorio": { title: "Documento emitido por el Organismo Oficial correspondiente a su estatus migratorio", type: "boolean" },
                                        "pasaporteVigente": { title: "Pasaporte vigente, incluyendo sellos de entrada y salida", type: "boolean" },
                                        "imagenIdentificacion": { title: "Imagen de una o más documentos de identificación de su país de origen", type: "boolean" },
                                        "declaracionImpuesto": { title: "Declaración de Impuesto de su país de origen", type: "boolean" },
                                        "fuenteIngresos": { title: "Documentos que comprueben la fuente de sus ingresos", type: "boolean" }
                                    },
                                },
                            }
                        },
                    }
                },
            ]
        },
        "PEP": {
            oneOf: [
                {
                    properties: {
                        "PEP": {
                            const: "Si, es PEP y proporcionó DJP"
                        },
                        "personasPoliticamenteExpuestas": {
                            title: "Personas Políticamente Expuestas",
                            type: "object",
                            properties: {
                                "documentosTipoPersona": { title: "Documento requeridos de acuerdo al tipo de persona", type: "boolean" },
                                "declaracionJurada": { title: "Declaración Jurada de Patrimonio o decreto que lo designa al cargo público", type: "boolean" }
                            },
                        }
                    }
                },
                {
                    properties: {
                        "PEP": {
                            const: "Si, es PEP por Vinculación"
                        },
                        "personasPoliticamenteExpuestas": {
                            title: "Personas Políticamente Expuestas",
                            type: "object",
                            properties: {
                                "documentosTipoPersona": { title: "Documento requeridos de acuerdo al tipo de persona", type: "boolean" },
                                "declaracionJurada": { title: "Declaración Jurada de Patrimonio o decreto que lo designa al cargo público", type: "boolean" }
                            },
                        }
                    }
                },
                {
                    properties: {
                        "PEP": {
                            const: "No es PEP"
                        }
                    }
                },
                {
                    properties: {
                        "PEP": {
                            const: "Dejo de ser PEP acorde a la Ley"
                        }
                    }
                },
                {
                    properties: {
                        "PEP": {
                            const: "La coincidencia PEP no es acorde a la Ley, No sera considerado una PEP"
                        }
                    }
                },
            ]
        },
    },
};



form.uiSchema = {
    "ui:order": [
        "*",
        "beneficiarioFinal",
        "procedenciaDestinoFondos",
        "validacionAnexos",
        "debidaDiligenciaCumplimiento",
    ],
    "validacionDocumentosRequeridos": {
        "nacional": { "ui:widget": "checkboxes", },
        "menoresEdad": { "ui:widget": "checkboxes", },
        "extranjeroResidente": { "ui:widget": "checkboxes", },
        "extranjeroNoResidente": { "ui:widget": "checkboxes", },
    },
    "procedenciaDestinoFondos": {
        "origenFondos": {
            "ui:widget": "radio",
            "ui:options": {
                inline: true
            },
        },
    },
    "validacionAnexos": {
        "ui:widget": "checkboxes",
    },
    "debidaDiligenciaCumplimiento": {
        "observacionesAreaCumplimiento": {
            "ui:widget": "textarea",
            "ui:options": {
                rows: 4
            },
        },
        "comentarios": {
            "ui:widget": "textarea",
            "ui:options": {
                rows: 4
            },
        },
        "revisionEnListas": {
            "complianceScreening": multiFileUploadField.uiSchema,
            "openCorporates": multiFileUploadField.uiSchema,
            "consultaWeb": multiFileUploadField.uiSchema,
        }

    },
}

form.objectMap = {
    // Fields not implemented:
    "clients[$idx].retailClientDueDiligenceReport.complianceScreeningFileList.items": multiFileUploadField.mapping(
        'debidaDiligenciaCumplimiento.revisionEnListas.complianceScreening'
    ),
    "clients[$idx].retailClientDueDiligenceReport.openCorporatesFileList.items": multiFileUploadField.mapping(
        "debidaDiligenciaCumplimiento.revisionEnListas.openCorporates"
    ),
    "clients[$idx].retailClientDueDiligenceReport.webSearchFileList.items": multiFileUploadField.mapping(
        "debidaDiligenciaCumplimiento.revisionEnListas.consultaWeb"
    ),
    "clients[$idx].retailClientDueDiligenceReport.webSearchResult": "debidaDiligenciaCumplimiento.revisionEnListas.resultadoConsultaWeb",

    "clients[$idx].retailClientDueDiligenceReport.inOFACList": true,
    "clients[$idx].retailClientDueDiligenceReport.inONUList": true,
    "clients[$idx].retailClientDueDiligenceReport.riskLevel": "nivelRiesgo",
    "clients[$idx].retailClientDueDiligenceReport.personType": "tipoPersona",
    "clients[$idx].retailClientDueDiligenceReport.politicalExposedPerson": "PEP",
    "clients[$idx].retailClientDueDiligenceReport.clientType": "tipoCliente",
    "clients[$idx].retailClientDueDiligenceReport.nationalCopyOfId": "validacionDocumentosRequeridos.nacional.copiaCedula", // true
    "clients[$idx].retailClientDueDiligenceReport.nationalIncomeDocument": "validacionDocumentosRequeridos.nacional.documentosFuenteIngresos", // true
    "clients[$idx].retailClientDueDiligenceReport.nationalSecondFormOfId": "validacionDocumentosRequeridos.nacional.segundaIdentificacion", // true
    "clients[$idx].retailClientDueDiligenceReport.nationalCreditReport": "validacionDocumentosRequeridos.nacional.reporteInfoCredenticia", // true

    "clients[$idx].retailClientDueDiligenceReport.residentAlienCopyOfResidenceCard": "validacionDocumentosRequeridos.extranjeroResidente.cedulaIdentidad", // true
    "clients[$idx].retailClientDueDiligenceReport.residentAlienCopyOfPassport": "validacionDocumentosRequeridos.extranjeroResidente.pasaporteVigente", // true
    "clients[$idx].retailClientDueDiligenceReport.residentAlienNationalityId": "validacionDocumentosRequeridos.extranjeroResidente.imagenIdentificacion", // true
    "clients[$idx].retailClientDueDiligenceReport.residentAlienCountryOfOriginTaxes": "validacionDocumentosRequeridos.extranjeroResidente.declaracionImpuesto", // true
    "clients[$idx].retailClientDueDiligenceReport.residentAlientIncomeReport": "validacionDocumentosRequeridos.extranjeroResidente.fuenteIngresos", // true

    "clients[$idx].retailClientDueDiligenceReport.underageCopyOfId": "validacionDocumentosRequeridos.menoresEdad.cedulaIdentidadMenor", // true
    "clients[$idx].retailClientDueDiligenceReport.underageNIIU": "validacionDocumentosRequeridos.menoresEdad.numUnicoIdentidad", // true
    "clients[$idx].retailClientDueDiligenceReport.underageBirthCertificate": "validacionDocumentosRequeridos.menoresEdad.actaNacimiento", // true
    "clients[$idx].retailClientDueDiligenceReport.underagePowerOfAttorney": "validacionDocumentosRequeridos.menoresEdad.poderRepresentativo", // true
    "clients[$idx].retailClientDueDiligenceReport.underageTutorRepresentation": "validacionDocumentosRequeridos.menoresEdad.sentenciaAcreditada", // true

    "clients[$idx].retailClientDueDiligenceReport.nonResidentAlienCopyOfResidenceCard": "validacionDocumentosRequeridos.extranjeroNoResidente.estatusMigratorio", // true
    "clients[$idx].retailClientDueDiligenceReport.nonResidentAlienCopyOfPassport": "validacionDocumentosRequeridos.extranjeroNoResidente.pasaporteVigente", // true
    "clients[$idx].retailClientDueDiligenceReport.nonResidentAlienNationalityId": "validacionDocumentosRequeridos.extranjeroNoResidente.imagenIdentificacion", // true
    "clients[$idx].retailClientDueDiligenceReport.nonResidentAlienCountryOfOriginTaxes": "validacionDocumentosRequeridos.extranjeroNoResidente.declaracionImpuesto", // true
    "clients[$idx].retailClientDueDiligenceReport.nonResidentAlientIncomeReport": "validacionDocumentosRequeridos.extranjeroNoResidente.fuenteIngresos", // true

    "clients[$idx].retailClientDueDiligenceReport.pepDocumentsRequired": "validacionDocumentosRequeridos.personasPoliticamenteExpuestas.documentosTipoPersona", // true
    "clients[$idx].retailClientDueDiligenceReport.pepNetWorthDeclaration": "validacionDocumentosRequeridos.personasPoliticamenteExpuestas.declaracionJurada", // true

    "clients[$idx].retailClientDueDiligenceReport.finalBeneficiary": "beneficiarioFinal.identificacionBeneficiarioFinal",// must be number
    "clients[$idx].retailClientDueDiligenceReport.isFundsOrigin": "procedenciaDestinoFondos.origenFondos", // true
    "clients[$idx].retailClientDueDiligenceReport.fundsDestination": "procedenciaDestinoFondos.destinoFondos",// must be number

    "clients[$idx].retailClientDueDiligenceReport.anexedListConsultations": "validacionAnexos.consultasListas", // true
    "clients[$idx].retailClientDueDiligenceReport.anexedRiskMatrix": "validacionAnexos.matrizRiesgo", // true

    "clients[$idx].retailClientDueDiligenceReport.worldCheckResult": "debidaDiligenciaCumplimiento.revisionEnListas.resultadoConsultaWorldCheck",
    "clients[$idx].retailClientDueDiligenceReport.openCorporateResult": "debidaDiligenciaCumplimiento.revisionEnListas.resultadoConsultaOpenCorporates",
    "clients[$idx].retailClientDueDiligenceReport.areaComments": "debidaDiligenciaCumplimiento.observacionesAreaCumplimiento",
    "clients[$idx].retailClientDueDiligenceReport.revisionDate": "debidaDiligenciaCumplimiento.fechaRevision",
    // "clients[$idx].retailClientDueDiligenceReport.dueDiligenceResult": "debidaDiligenciaCumplimiento.resultadoDebidaDiligencia",
    // "clients[$idx].retailClientDueDiligenceReport.dueDiligenceCaseReturnReason": "debidaDiligenciaCumplimiento.razonDevolucion",
    "clients[$idx].retailClientDueDiligenceReport.comments": "debidaDiligenciaCumplimiento.comentarios"
}


export default form;